export default __webpack_public_path__ + "static/media/asphaltBack1.2830a2c4.png";